<template>
  <div id="menu-button" :class="{ 'active': isActive }">
    <div class="menu-burger"></div>
  </div>
</template>

<script>
export default {
  name: 'TheHamburger',

  props: {
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .burger-style {
    width: 2rem;
    height: 3px;
    border-radius: 2px;
    background-color: $white;
    box-shadow: 0 2px 5px rgba($black, 0.3);
    transition: all 0.2s ease-in-out;
  }

  #menu-button {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.25rem;
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    transform: rotate(180deg);

    &.active {
      .menu-burger {
        transform: translateX(-3rem);
        background-color: transparent;
        box-shadow: none;

        &::before {
          transform: rotate(45deg) translate(35px, -35px);
        }

        &::after {
          transform: rotate(-45deg) translate(35px, 35px);
        }
      }
    }

    .menu-burger {
      @extend .burger-style;

      &::before,
      &::after {
        @extend .burger-style;
        content: "";
        position: absolute;
      }

      &::before {
        transform: translateY(-0.625rem);
      }

      &::after {
        transform: translateY(0.625rem);
      }
    }
  }
</style>
